module.exports = __webpack_public_path__ + "static/media/bhsMaintenance.1bd8c1a0.jpg";